var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcKygui(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1652",
    "data-name": "Rectangle 1652",
    width: 16,
    height: 16,
    transform: "translate(8 8)",
    fill: "#898989",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_Kygui",
    transform: "translate(-8 -8)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hand",
    d: "M11.148,8.877A7.374,7.374,0,0,1,15.37,10.26l.646.462v1.537l-1.373-.982a6.129,6.129,0,0,0-3.509-1.15h-4.4a.5.5,0,0,0-.281.914,1.272,1.272,0,0,0,.361.183c.243.035,3.023.333,4.847.525l-.131,1.243c-1.42-.15-4.745-.5-4.937-.538a2.4,2.4,0,0,1-.842-.38,1.751,1.751,0,0,1-.413-.4l-.006.006-3-2.944a.625.625,0,0,0-.876.892l4.639,4.552a1.96,1.96,0,0,0,1.38.564h8.544V16H7.472a3.2,3.2,0,0,1-2.256-.922L.577,10.526A1.875,1.875,0,0,1,3.2,7.849L5.191,9.8a1.751,1.751,0,0,1,1.541-.921h4.416M4.016,5.719V1.875A1.877,1.877,0,0,1,5.891,0h5.281a1.877,1.877,0,0,1,1.875,1.875V5.719a1.877,1.877,0,0,1-1.875,1.875H5.891A1.877,1.877,0,0,1,4.016,5.719Zm1.25,0a.626.626,0,0,0,.625.625h5.281a.626.626,0,0,0,.625-.625V1.875a.626.626,0,0,0-.625-.625H5.891a.626.626,0,0,0-.625.625ZM9.7,2.5H7.328V3.75H9.7Zm0,0",
    transform: "translate(7.984 8)",
    fill: "#898989"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKygui);
export default __webpack_public_path__ + "static/media/ic_Kygui.6bbc2761b87c017b78e91d3bf3647e22.svg";
export { ForwardRef as ReactComponent };